import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CheckmarkIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M20.7 5.3c.4.4.4 1 0 1.4l-11 11a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.4L9 15.6 19.3 5.3a1 1 0 0 1 1.4 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CheckmarkIcon;
